import { render } from "./PatientReferrals.vue?vue&type=template&id=333fd36e&lang=pug"
import script from "./PatientReferrals.vue?vue&type=script&lang=js"
export * from "./PatientReferrals.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__